import * as LZStringModule from 'lz-string'
import { State } from './reducers/rootReducer'
import { defaultState as pendingRequestsDefaultState } from './reducers/pendingRequestsReducer'

const LZString = (LZStringModule as any).default || LZStringModule

export const STORAGE = window.sessionStorage
export const STORAGE_NAME = 'dcc-redux-state'
export const STORAGE_NAME_COMPRESSED = 'dcc-redux-state-compressed'

// Only compress these large/complex state parts
const COMPRESSED_STATE_KEYS = [
    'vwnRecommendationsForModel',
    'vwnModelsWithRecommendations',
    'aiRecommendationsForModel',
    'comparisonCarlineStructure',
    'comparisonResultData',
    'allModelsData',
    'equipmentGroupsForCarlineAndModel',
]

// States that should not be persisted at all
const EXCLUDED_STATE_KEYS = [
    'router',
    'trackingIsReady',
    'languageIsLoaded',
    'infoModal',
    'notifications',
    'ui',
    'pendingRequests',
    'e3DGrpAuth',
    'orderHandoverFailed',
]

let debounceTimer: number | null = null
const DEBOUNCE_DELAY = 300

export const setPersistedState = (state: State): void => {
    if (debounceTimer !== null) {
        clearTimeout(debounceTimer)
    }

    debounceTimer = window.setTimeout(() => {
        try {
            const toCompress = {}
            const toStoreUncompressed = {}

            Object.keys(state).forEach(key => {
                if (EXCLUDED_STATE_KEYS.includes(key)) {
                    return
                }

                if (COMPRESSED_STATE_KEYS.includes(key)) {
                    toCompress[key] = state[key]
                } else {
                    toStoreUncompressed[key] = state[key]
                }
            })

            STORAGE.setItem(STORAGE_NAME, JSON.stringify(toStoreUncompressed))

            setTimeout(() => {
                try {
                    const compressedData = LZString.compressToUTF16(JSON.stringify(toCompress))
                    STORAGE.setItem(STORAGE_NAME_COMPRESSED, compressedData)
                } catch (e) {
                    console.error('[PersistState] Failed to save compressed state:', e)
                }
            }, 0)
        } catch (e) {
            console.error('[PersistState] Failed to save state:', e)
        }
    }, DEBOUNCE_DELAY)
}

export const getPersistedState = (): Partial<State> | undefined => {
    try {
        const uncompressedData = STORAGE.getItem(STORAGE_NAME)

        const compressedData = STORAGE.getItem(STORAGE_NAME_COMPRESSED)

        if (!uncompressedData && !compressedData) {
            return undefined
        }

        const uncompressedState = uncompressedData ? JSON.parse(uncompressedData) : {}

        let compressedState = {}
        if (compressedData) {
            const decompressedRaw = LZString.decompressFromUTF16(compressedData)
            if (decompressedRaw) {
                compressedState = JSON.parse(decompressedRaw)
            }
        }

        return {
            ...uncompressedState,
            ...compressedState,
            pendingRequests: pendingRequestsDefaultState,
        }
    } catch (e) {
        console.error('[PersistState] Failed to load state:', e)
        return undefined
    }
}
